/**
 * Shared JSX cell for the Transaction Ledger tables (v2 — DNKADM-0149 U2).
 *
 * The reservation reference cell reused by both the payments and credits ledger
 * tables: a best-effort `reservationUuid` renders the `/reservations?reservation=<uuid>`
 * deep link (DNKADM-0147); otherwise the plain `reservationId` text (the forward-compat
 * DNKAPI-0281 state — no link until the uuid field ships); with neither, an em dash.
 * The pure text helpers live in `./transactionFormat` (component-only here keeps Fast
 * Refresh happy).
 */
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export function ReservationRefCell({
  reservationUuid,
  reservationId,
}: {
  reservationUuid: string | null;
  reservationId: string | null;
}) {
  if (reservationUuid !== null) {
    return (
      <Link
        component={RouterLink}
        to={`/reservations?reservation=${encodeURIComponent(reservationUuid)}`}
        sx={{ fontSize: 12 }}
      >
        View reservation
      </Link>
    );
  }
  if (reservationId !== null) {
    return <span>{reservationId}</span>;
  }
  return <span>—</span>;
}
